var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarecentericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_162_2076",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 38,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4H46.1951V52.5333H9V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_162_2076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1513 22.5757C46.1513 32.8242 27.5932 52.5547 27.5932 52.5547C27.5932 52.5547 9.03458 32.8242 9.03458 22.5757C9.03458 12.326 17.3436 4.01782 27.5927 4.01782C37.8418 4.01782 46.1513 12.326 46.1513 22.5757Z",
    fill: "#598CDD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_162_2076",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 12.6H38V33H17.6V12.6Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_162_2076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.35 12.6H25.25V20.25H17.6V25.35H25.25V33H30.35V25.35H38V20.25H30.35V12.6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarecentericon);
export default __webpack_public_path__ + "static/media/carecentericon.fcafc67d23b518859578dc1ccffafdeb.svg";
export { ForwardRef as ReactComponent };